import fetchAPI from '../../../lib/utils/fetch-api'
import {
  setClaimFormFailed,
  setClaimFormLoading,
  setClaimFormAlert,
  setClaimFormData,
} from './actions'
import { handleStageConflictResponse } from '../../lib/stage-conflict'

export function getClaimData(id: number | string) {
  return async dispatch => {
    dispatch(setClaimFormLoading())
    try {
      const response = (await fetchAPI(`/api/claim/${id}`)) || []
      if (response['errors'] || response?.error) {
        let error = response['errors'] || response?.error
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setClaimFormFailed(error))
      }
      return dispatch(setClaimFormData(response))
    } catch (err) {
      console.error(err)
      return dispatch(setClaimFormFailed('При загрузки полей возникла ошибка'))
    }
  }
}

interface IClaimPostData {
  stage?: string
  dealer_code?: number
}

export function updateFormData(id: string | number, data: IClaimPostData) {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/claim/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
      })

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return { error, incompleteWorks: response['incompleteWorks'] || null }
      }
      dispatch(setClaimFormData(response))
      return { error: null, data: response }
    } catch (err) {
      return { error: err as string, incompleteWorks: null }
    }
  }
}

export function nextStage(id, formData) {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/claim/${id}`, {
        method: 'POST',
        body: JSON.stringify(formData),
      })

      if (handleStageConflictResponse(response, () => dispatch(getClaimData(id)))) {
        return { error: null, data: null }
      }

      if (response?.['alert']) {
        const alert = response['alert']
        dispatch(setClaimFormAlert(alert))
        return { error: null, data: null, alert }
      }

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return { error, incompleteWorks: response['incompleteWorks'] || null }
      }

      dispatch(setClaimFormData(response))
      return { error: null, data: response }
    } catch (err) {
      return { error: err as string, incompleteWorks: null }
    }
  }
}
